let loadCount = 0;
let lastLoadTime = 0;

export function debugDataLoading(event: string, details?: any) {
  const now = Date.now();
  const timeSinceLastLoad = lastLoadTime ? now - lastLoadTime : 0;
  
  console.group(`📊 Data Loading Event #${++loadCount}: ${event}`);
  console.log('Time since last event:', timeSinceLastLoad, 'ms');
  console.log('Stack trace:', new Error().stack?.split('\n').slice(2, 5).join('\n'));
  
  if (details) {
    console.log('Details:', details);
  }
  
  console.groupEnd();
  
  lastLoadTime = now;
}

export function resetLoadCounter() {
  loadCount = 0;
  lastLoadTime = 0;
}